module.exports = __webpack_public_path__ + "images/category_lp/furniture/store_images/4_969e14ad1bfd07d737292eefd8c69c59.png";